import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class FinalSale extends HTMLElement {
    connectedCallback() {
        const closestSection = this.closest('.shopify-section, dialog');
        if (!closestSection) return;
        closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateFinalSale);
    }

    disconnectedCallback() {
        const closestSection = this.closest('.shopify-section, dialog');
        if (!closestSection) return;
        closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateFinalSale);
    }

    /**
     * Updates the final sale message and line item property.
     * @param {VariantUpdateEvent} event - The variant update event.
     */
    updateFinalSale = (event) => {
        if (event.detail.data.newProduct) {
            this.dataset.productId = event.detail.data.newProduct.id;
        } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
            return;
        }

        const newFinalSale = event.detail.data.html.querySelector('final-sale [ref="finalSaleContainer"]');
        const currentFinalSale = this.querySelector('[ref="finalSaleContainer"]');
        if (!newFinalSale || !currentFinalSale) return;

        if (currentFinalSale.innerHTML !== newFinalSale.innerHTML) {
            currentFinalSale.replaceWith(newFinalSale);
        }
    };
}

if (!customElements.get('final-sale')) {
    customElements.define('final-sale', FinalSale);
}
